import { render } from "./QuizAddPage.vue?vue&type=template&id=c0f68b9c&scoped=true"
import script from "./QuizAddPage.vue?vue&type=script&lang=js"
export * from "./QuizAddPage.vue?vue&type=script&lang=js"

import "./QuizAddPage.vue?vue&type=style&index=0&id=c0f68b9c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f68b9c"]])

export default __exports__